// extracted by css-extract-rspack-plugin
export default {"root":"root-hfC2jU","base":"base-ISwRK3","compact":"compact-uya2ts","section":"section-ufNoWA","label":"label-Z63bGX text-lg"};